const LocationsModal = {
    init: () => {
        // $('.header__nav-locations').click(function() {
        //     $('.select-locations').removeClass('hidden');
        //     return false;
        // });

        // $('#select-locations .select-locations__item').click(function() {
        //     $('.select-locations').addClass('hidden');
        // });
    },
}

Object.freeze(LocationsModal);

export default LocationsModal;


// WEBPACK FOOTER //
// ./scripts/components/LocationsModal.js